export default __webpack_public_path__ + "static/media/bariol_thin-webfont.eadd3532.woff2";